import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AuthFooter = () => {
	const { t } = useTranslation();

	return (
		<footer className="l__authFooter">
			<ul>
				<li>{t("common.components.AuthFooter.companyName")}</li>
				<li>{t("common.components.AuthFooter.present")}</li>
				<li>{t("common.components.AuthFooter.companyNumber")}</li>
				<li>{t("common.components.AuthFooter.mailOrderBusiness")}</li>
			</ul>
			<ul>
				<li>{t("common.components.AuthFooter.addres")}</li>
				{/* <li>{t("common.components.AuthFooter.tel")}</li> */}
				<li>E-mail : cs@boomco.org</li>
				<li>
					<Link to={"https://startup.gitbal.io/policy/terms"} target="_blank">
						{t("common.components.AuthFooter.termsOfUse")}
					</Link>
				</li>
				<li>
					<Link to={"https://startup.gitbal.io/policy/privacy"} target="_blank">
						{t("common.components.AuthFooter.privacyPolicy")}
					</Link>
				</li>
			</ul>
		</footer>
	);
};

export default AuthFooter;
